// Entorno de DESARROLLO (sustituye a environment.ts con la configuración `development`).
//
// TODO: cambiar `apiUrl` a la URL real de la API de desarrollo cuando esté disponible.
//       De momento se usa la misma URL que producción.
export const environment = {
  production: false,
  apiUrl: 'https://app.rotulosvelazquez.com/api/v1'
};
